angular.module('filters')
    .filter('deviceName', () => (device) => {

        if (!device || !device.attributes) {

            return 'Unknown';

        }

        if (device) {

            if (device.attributes.alias) {

                return device.attributes.alias;

            } else if (device.attributes.name) {

                return device.attributes.name;

            } else if (device.attributes.brand && device.attributes.model) {

                if (
                    device.attributes.model
                        .toLowerCase()
                        .indexOf(device.attributes.brand.toLowerCase()) > -1) {

                    return device.attributes.model;

                }
                return [device.attributes.brand, device.attributes.model].join(' ');

            } else if (device.attributes.brand) {

                return device.attributes.brand;

            } else if (device.attributes.model) {

                return device.attributes.model;

            }

            return 'Unknown';

        }

        return undefined;

    });



// WEBPACK FOOTER //
// ./scripts/common/filters/deviceName.js